
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_11012_456580)"}},[_c('path',{attrs:{"d":"M18.333 5.833h-4.166v-5a.833.833 0 10-1.667 0v5h-5v-5a.833.833 0 10-1.667 0v5H1.667a.833.833 0 100 1.667H2.5V10c0 3.853 2.922 7.035 6.667 7.45v1.717a.833.833 0 101.666 0V17.45C14.577 17.034 17.5 13.853 17.5 10V7.5h.833a.833.833 0 100-1.667z","fill":"#2C8DFF"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_11012_456580"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h20v20H0z"}})])])])
          )
        }
      }
    